import { createContext, useContext } from 'solid-js';
import type { JSX } from 'solid-js';

/* Holds the list of style names (strings) currently active from ancestor contexts.
   Provided at the page level by SectionList and updated at each nested Styles component. */

const ActiveStylesContext = createContext<() => string[]>(() => []);

export function ActiveStylesProvider(P: { activeStyles: () => string[], children: JSX.Element })
{
	return (
		<ActiveStylesContext.Provider value={P.activeStyles}>
			{P.children}
		</ActiveStylesContext.Provider>
	);
}

export function useActiveStyles(): () => string[]
{
	return useContext(ActiveStylesContext);
}
